module.exports = __webpack_public_path__ + "img/ee2ee2e.jpg";